import { ListParams } from '../http';

export class ProductInventoryListParams extends ListParams {
    first?: number;
    max?: number;
    sort_field?: string;
    sort_asc?: boolean;

    only_active?: boolean;

    baseQuery?: string;

    system_id?: string;
    external_id?: string;
    external_system_id?: string;
    ean?: string;
    name?: string;
    category?: string;
    category_pl?: string;
    weight_volume_from?: number;
    weight_volume_to?: number;
    unit_of_measurement?: string;
    price_from?: number;
    price_to?: number;
    returnable_packaging?: boolean;
    statuses?: string;

    constructor(partial: Partial<ProductInventoryListParams> = {}) {
        super(partial);

        this.first = partial.first;
        this.max = partial.max;
        this.sort_field = partial.sort_field;
        this.sort_asc = partial.sort_asc;

        this.only_active = partial.only_active;

        this.baseQuery = partial.baseQuery;

        this.system_id = partial.system_id;
        this.external_id = partial.external_id;
        this.external_system_id = partial.external_system_id;
        this.ean = partial.ean;
        this.name = partial.name;
        this.category = partial.category;
        this.category_pl = partial.category_pl;
        this.weight_volume_from = partial.weight_volume_from;
        this.weight_volume_to = partial.weight_volume_to;
        this.unit_of_measurement = partial.unit_of_measurement;
        this.price_from = partial.price_from;
        this.price_to = partial.price_to;
        this.returnable_packaging = partial.returnable_packaging;
        this.statuses = partial.statuses;
    }
}